import { useMemo } from 'react';
import { PlanEntitlementKey } from '../../../../api/graphql/generated';
import { useHasFeature } from '../../../../api/hooks/feature.hooks';
import { useHasEntitlement } from '../../../../components/plan/plan-entitlement-hooks';
import { useMachineContext } from '../../../../pages/machine/machine-context-provider';

interface ScratchpadRecommendationAccess {
  isEnabled: boolean;
  isVisible: boolean;
}

export const useScratchpadRecommendationAccess =
  (): ScratchpadRecommendationAccess => {
    // TODO replace with a tenant preference
    const hasScratchpadRecommendations = useHasFeature<boolean>(
      'beacon-scratchpad-recommendations'
    );

    const hasRecommendationEntitlement = useHasEntitlement(
      PlanEntitlementKey.AI_RECOMMENDATIONS
    );

    const { hideRecommendations } = useMachineContext();

    const hasRecommendations = useMemo<ScratchpadRecommendationAccess>(() => {
      return {
        isEnabled: hasRecommendationEntitlement && !hideRecommendations,
        isVisible: !hideRecommendations && hasScratchpadRecommendations,
      };
    }, [
      hasScratchpadRecommendations,
      hasRecommendationEntitlement,
      hideRecommendations,
    ]);

    return hasRecommendations;
  };
